// Optionskarten mit Erklärung (Prototyp „Wechsel-Erkennung“): Radio-Punkt, fetter Titel, Text aus dem Code.
import type { KeyboardEvent, ReactNode } from 'react';
import { OPTION_KARTE } from './form-stil';

export interface FormOption<K extends string> { wert: K; titel: string; text: ReactNode }

export function FormOptionen<K extends string>({ kopf, optionen, wert, onChange, beschriftung }: {
  /** Kopfzeile über den Optionen (Text aus dem Code) */
  kopf?: ReactNode;
  optionen: readonly FormOption<K>[];
  wert: K;
  onChange: (wert: K) => void;
  /** Screenreader-Bezeichnung der Gruppe */
  beschriftung: string;
}) {
  const tastatur = (e: KeyboardEvent<HTMLDivElement>) => {
    if (!['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft'].includes(e.key)) return;
    e.preventDefault();
    const vor = e.key === 'ArrowDown' || e.key === 'ArrowRight';
    const i = optionen.findIndex(o => o.wert === wert);
    const n = optionen.length;
    const naechste = optionen[(i + (vor ? 1 : n - 1) + n) % n];
    if (naechste) onChange(naechste.wert);
  };
  return (
    <div className="flex flex-col" style={{ gap: 8, padding: '10px 12px', borderRadius: 15, background: OPTION_KARTE.flaeche, boxShadow: OPTION_KARTE.ring }}>
      {kopf && <span style={{ fontSize: 13, fontWeight: 700, color: OPTION_KARTE.kopf }}>{kopf}</span>}
      <div role="radiogroup" aria-label={beschriftung} onKeyDown={tastatur} className="flex flex-col" style={{ gap: 8 }}>
        {optionen.map(o => {
          const an = o.wert === wert;
          return (
            <button key={o.wert} type="button" role="radio" aria-checked={an} tabIndex={an ? 0 : -1} onClick={() => onChange(o.wert)}
              className="flex w-full cursor-pointer items-start border-none text-left"
              style={{ gap: 10, padding: '11px 12px', borderRadius: 13, font: 'inherit', background: an ? OPTION_KARTE.an : OPTION_KARTE.aus, boxShadow: an ? OPTION_KARTE.anRing : OPTION_KARTE.ausRing, transition: 'background .2s, box-shadow .2s' }}>
              <span aria-hidden className="flex shrink-0 items-center justify-center rounded-full" style={{
                width: 18, height: 18, marginTop: 1, background: an ? OPTION_KARTE.punktAn : 'transparent', boxShadow: an ? 'none' : OPTION_KARTE.punktAus, transition: 'all .2s',
              }}>
                <span className="rounded-full" style={{ width: 7, height: 7, background: an ? OPTION_KARTE.punktKern : 'transparent' }} />
              </span>
              <span style={{ fontSize: 12.5, fontWeight: 500, lineHeight: 1.45, color: 'rgba(255,255,255,0.72)' }}>
                <b style={{ color: '#fff', fontWeight: 800 }}>{o.titel}</b> — {o.text}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
